import React from 'react';
import PropTypes from 'prop-types';
import Tag from '../Tag/Tag.jsx';

const TagList = ({tags}) => {
    return (
        <ul className="tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-gap-4 tw-p-0">
            {tags.map((tag) => {
                return <Tag key={tag} name={tag} />;
            })}
        </ul>
    );
};

TagList.propTypes = {
    tags: PropTypes.array.isRequired,
};

export default TagList;
